import { render, staticRenderFns } from "./ServiceModal.vue?vue&type=template&id=38ae12a6"
import script from "./ServiceModal.vue?vue&type=script&lang=ts"
export * from "./ServiceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports